export default __webpack_public_path__ + "static/media/import.00d9cbcc.svg";